import { render } from "./OldInHouseCustomer.vue?vue&type=template&id=5a32e505"
import script from "./OldInHouseCustomer.vue?vue&type=script&lang=js"
export * from "./OldInHouseCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__